<template>
    <v-card class="ma-2 contact-info-card">
        <v-card-text class="card-text-contacts">
            <div class="contact-info-title">Contact info</div>
            <div class="phones-group" v-for="(phone, index) in phoneNumbers" :key="index">
                 <v-select v-model="phone.prefix" label="Prefix" content-class="users-coordinator" class="contact-phone-skype phone-prefix" :items="phonePrefix" 
                    bottom :disabled="!isEditEnabled"></v-select>
                <v-text-field :value="getPhone(phone)" :mask="getPhoneMask(phone)" @input="onChangePhone($event, index)"
                    label="Number" class="contact-phone-skype phone-number" :disabled="!isEditEnabled"></v-text-field>
                <v-tooltip v-if="index === 0" bottom>
                    <v-btn :disabled="!isEditEnabled" flat color="black" @click="addPhone()" slot="activator" class="add-phone-btn">
                        <v-icon small color="indigo">mdi-plus</v-icon>
                    </v-btn>
                    <div>Add new phone</div>
                </v-tooltip>
                <v-tooltip v-else bottom>
                    <v-btn :disabled="!isEditEnabled" flat color="black" @click="removePhone(index)" slot="activator" class="add-phone-btn">
                        <v-icon small color="indigo">mdi-minus</v-icon>
                    </v-btn>
                    <div>Remove phone</div>
                </v-tooltip>
            </div>
            <v-text-field :disabled="!isEditEnabled" v-model="skype" label="Skype" :rules="skypeRules" class="contact-phone-skype input-card"></v-text-field>
            <v-text-field :disabled="!isEditEnabled" v-model="telegram" :rules="telegramRules" label="Telegram" :prefix="'@'" class="contact-telegram input-card"></v-text-field>
            <v-text-field :disabled="!isEditEnabled" v-model="rocketChat" label="RocketChat" :prefix="'@'" :rules="skypeRules" class="contact-rocketchat input-card"></v-text-field>
            <v-text-field :disabled="!isEditEnabled" v-model="СontactEmail" :rules="emailRules" label="Email" class="contact-phone-skype input-card"></v-text-field>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import phonePrefix from '@/constants/phone-prefix';

    export default {
        name: 'EmployeeContactInfo',
        data() {
            return {
                phonePrefix: phonePrefix,
                telegramRules: [
                    (v) => /^([\w-+.])*$/.test(v) || 'You can use a-z, 0-9 and underscores'
                ],
                skypeRules: [
                    (v) => /^([\w-.])*$/.test(v) || 'You can use a-z, 0-9 , dash and underscores'
                ],
                emailRules: [
                    (v) => !!v || '',
                    (v) => /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.[A-Za-z0-9]{2,3})+$/.test(v) || 'Invalid email'
                ]
            };
        },
        computed: {
            ...mapGetters({
                employeeRocketChat: 'getEmployeeRocketChat',
                employee: 'getEmployee',
                contactEmail: 'getContactEmail'
            }),
            phoneNumbers: {
                get() {
                    return this.$store.state.employees.employee.phoneNumbers;
                }
            },
            skype: {
                get() {
                    return this.$store.state.employees.employee.skype;
                },
                set(value) {
                    this.editEmployeeSkype(value);
                }
            },
            telegram: {
                get() {
                    return this.$store.state.employees.employee.telegram
                        ? this.$store.state.employees.employee.telegram.replace('@', '') : '';
                },
                set(value) {
                    this.editEmployeeTelegram('@' + value);
                }
            },
            rocketChat: {
                get() {
                    return this.employeeRocketChat ? this.employeeRocketChat.replace('@', '') : '';
                },
                set(value) {
                    this.editEmployeeRocketChat(`@${value}`);
                }
            },
            СontactEmail: {
                get() {
                    return this.contactEmail;
                },
                set(value) {
                    this.editEmployeeContactEmail(value);
                }
            },
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'editEmployeePhoneNumber',
                'addEmployeePhoneNumber',
                'removeEmployeePhoneNumber',
                'editEmployeeSkype',
                'editEmployeeTelegram',
                'editEmployeeRocketChat',
                'editEmployeeContactEmail'
            ]),
            getPhone(phone) {
                return phone.number ? phone.number.replace(phone.prefix, '') : '';
            },
            onChangePhone(value, index) {
                this.phoneNumbers[index]['number'] = value ? `${this.phoneNumbers[index].prefix}${value}` : '';
                this.editEmployeePhoneNumber(this.phoneNumbers);
            },
            addPhone() {
                this.addEmployeePhoneNumber();
            },
            removePhone(index) {
                this.removeEmployeePhoneNumber(index);
            },
            getPhoneMask(phone) {
                switch (phone.prefix) {
                    case '+375':
                        return '(##) ###-##-##';
                    case '+7':
                        return '(###) ###-##-##';
                }
            }
        }
    };
</script>

<style scoped>

    .input-card >>> .input-group--text-field__prefix {
        font-size: 13px;
        margin-top: 7px;
    }
    .input-card >>> input {
        position: relative;
    }
    .contact-info-title {
        font-size: 20px;
        padding-top: 5px;
        padding-bottom: -14px;
    }
    .phones-group {
        display: flex;
        flex-direction: row;
    }
    .add-phone-btn >>> .btn__content {
        padding: 0;
    }
    .add-phone-btn {
        min-width: 24px;
        width: 24px;
        min-height: 24px;
        height: 24px;
        margin: 6px 0px 14px 6px;
        background-color: #CED2E6 !important;
    }
    .contact-rocketchat {
        margin-bottom: 10px;
    }
    .phone-prefix {
        font-size: 12px !important;
        flex: 0 0 6em;
        min-width: 20px !important;
    }
    .phone-number {
        flex: 11;
    }
    .card-text-contacts {
        padding-bottom: 24px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeContactInfo.vue